import { register } from "marko/components"
import component from "./component-browser.js"
register("QhocDQNV", component)